import { currentSessionToken } from "../Apis/token";
import axios from "axios";
import { GpsBaseURL } from "../api/DataApis";

const BASE_URL = GpsBaseURL;

const Logoutt = () => {
  // Clear localStorage or any authentication data
  localStorage.removeItem("uniqueToken");
  localStorage.removeItem("userdata");
  localStorage.clear(); // Clears all data in localStorage if necessary

  // Optionally, you can also clear cookies or session storage if used
  sessionStorage.clear();

  // Redirect to login
  window.location.href = `${process.env.PUBLIC_URL}/home`;
};

const request = async ({ url, method = "GET", data = null, params = null }) => {
  // alert("hello");

  try {
    let headers = await currentSessionToken(); // Fetch authorization token dynamically

    const axiosInstance = axios.create({
      baseURL: BASE_URL,
      headers,
    });

    // API request with dynamic method, body, and query parameters
    const response = await axiosInstance.request({
      url,
      method,
      data: method !== "GET" ? data : undefined, // Only include body for non-GET requests
      params: method === "GET" ? params : undefined, // Include query params only for GET
    });

    return response?.data || null;

  } catch (error) {
    console.error(`API Error in ${method} ${url}:`, error);
    if(error.response.data.statusCode === 407) {
      //alert("ok");
      Logoutt();

    } else {
      // Improved error handling with better feedback
      if (error.response) {
        console.error("Response Data:", error.response.data);
        console.error("Status Code:", error.response.status);
        return { error: true, message: error.response.data.message || "Something went wrong!" };
      }
    }

    return { error: true, message: "Network error. Please check your connection." };
  }
};

export default request;
